import { Component } from 'react';
import ReactDOM from 'react-dom';
import Draggable from 'react-draggable';

import SyntheticEventHelper from '@app/libs/syntheticEvent/SyntheticEventHelper';

class DraggableComponent extends Component {
  componentDidMount() {
    // eslint-disable-next-line react/no-find-dom-node
    const thisNode = ReactDOM.findDOMNode(this);
    if (thisNode) {
      thisNode.addEventListener('touchmove', SyntheticEventHelper.preventTouchMove, {
        passive: false,
      });
    }
  }

  componentWillUnmount() {
    // eslint-disable-next-line react/no-find-dom-node
    const thisNode = ReactDOM.findDOMNode(this);
    if (thisNode) {
      thisNode.removeEventListener('touchmove', SyntheticEventHelper.preventTouchMove);
    }
  }

  render() {
    return <Draggable {...this.props} />;
  }
}

export default DraggableComponent;
